<!-- 单个额度 -->
<template>
    <div class="w-3rem h-2_3rem rounded-circle position-relative">
        <!-- 阴影 -->
        <div :class="footClass" class="position-absolute w-100 h-100 top-0 start-0 rounded-circle bg-opacity-50 chips-shadow mt-_2rem">
            <div class="position-absolute top-0 start-0 end-0 bottom-0 rounded-circle"></div>
        </div>
        <!-- 表面 -->
        <div :class="faceClass" class="w-100 h-100 position-relative index-1 rounded-circle chips-face">
            <div class="position-absolute top-0 start-0 end-0 bottom-0 p-_3rem rounded-circle">
                <div :class="faceClass" class="w-100 h-100 rounded-circle p-_1rem small">
                    <div class="w-100 h-100 rounded-circle fw-bold d-flex justify-content-center align-items-center small chips-inner">{{chipText}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    props:{
        footClass:{
            type:Array,
            default:[]
        },//底部样式
        faceClass:{
            type:Array,
            default:[]
        },//表面样式
        chipText:String|Number,//文本
    }
}
</script>